import { AppState } from "../appState";

// Base selector to access Selected tab state
export const tabPositionSelector = (state: AppState) => state.tabPosition;

